import styles from './SectionHeading.module.css';

/**
 * @param {{ eyebrow?: string, title: string, description?: string, align?: 'left' | 'center' }} props
 */
export default function SectionHeading({ eyebrow, title, description, align = 'left' }) {
  return (
    <div className={`${styles.wrap} ${align === 'center' ? styles.center : ''}`}>
      {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
      <h2 className={styles.title}>{title}</h2>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  );
}
